const i18n = {
    0: {
        single: '（单选）',
        multi: '（多选）',
        submit: '提交',
        submitted: '已提交',
        submit_succ: '提交成功',
        submit_fail: '提交失败',
        form_required: '请填写必填项',
        go_login: '即将跳转登录',
        expired: '问卷已过期'
    },
    1: {
        single: '（單選）',
        multi: '（多選）',
        submit: '提交',
        submitted: '已提交',
        submit_succ: '提交成功',
        submit_fail: '提交失敗',
        form_required: '請填入必填項',
        go_login: '即將跳轉登入',
        expired: '問卷已過期'
    },
    2: {
        single: '(Single Answer)',
        multi: '(Multiple Answers)',
        submit: 'Submit',
        submitted: 'Submitted',
        submit_succ: 'Submission Successful',
        submit_fail: 'Submission Failed',
        form_required: 'Please Complete All Required Fields',
        go_login: 'Will Jump To Login Soon',
        expired: 'Expired'
    },
    5: {
        single: '（単一選択）',
        multi: '（複数選択）',
        submit: '提出する',
        submitted: '提出済み',
        submit_succ: '正常に送信されました',
        submit_fail: '送信に失敗しました',
        form_required: '必須項目が未入力です',
        go_login: 'すぐにログインにジャンプします',
        expired: '期限切れ'
    }
};

export const useI18n = (lang) => (key) => i18n[lang][key] || key;
